module.exports = __webpack_public_path__ + "img/lightbulb-01.9559e790.svg";